<app-header></app-header>
<div class="content">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<app-spinner *ngIf="spinnerService.isVisible$ | async"></app-spinner>
